<template>
    <CardPage :section="10" :page="9" next="/" nextLabel="Finish" :nextFunction="finish" :audio="true">
        <p>
            You are one of my smartest children (don’t tell the others!) For that, you’ve earned another sticker.
        </p>
        <ResponsiveImage :src="sticker.image" :alt="sticker.text"></ResponsiveImage>
    </CardPage>
</template>

<script>
import { get } from 'vuex-pathify';

export default {
    computed: {
        sticker: get('section10/sticker')
    },
    methods: {
        finish() {
            this.$store.set('section10/complete', true);
            this.$store.set('section10/sticker@earned', true);
        }
    }
};
</script>
